var MpCharts = {
    created: function() {},
    data: function() {
        return {
            DATE_FORMAT: 'YYYY-MM-DD HH:mm:ss',

            chart: null,
            chartOptions: {
				title: {
					text: 'Chart.js Time Scale'
				},
				scales: {
					xAxes: [{
                        type: 'time',
                        display: true,
						time: {
                            unit: 'minute',
							// parser: this.TIME_FORMAT,
                            // round: 'day'
                            unitStepSize: 5,
                            displayFormats: {
                                'minute': 'HH:mm a',
                            },
							tooltipFormat: 'll HH:mm'
						},
						scaleLabel: {
							display: false,
							labelString: 'Date'
                        },
                        gridLines: {
                            display: false,
                            color: 'rgba(220, 220, 220, 0.2)',
                            drawBorder: false,
                            zeroLineWidth: 0,
                        },
					}],
					yAxes: [{
                        ticks: {
                            beginAtZero: false,
                        },
						scaleLabel: {
							display: false,
							labelString: 'value'
                        },
                        gridLines: {
                            color: 'rgba(220, 220, 220, 0.2)',
                            drawBorder: false,
                            zeroLineWidth: 0,
                        },
					}]
                },
                layout: {
                    padding: {
                        top: 24,
                        right: 16,
                        bottom: 16,
                        left: 0
                    }
                },
                legend: {
                    display: false,
                },
                tooltips: {
                    intersect: false,
                    displayColors: false,
                    xPadding: 8,
                    yPadding: 8,
                    titleFontFamily: 'Inter',
                    titleFontSize: 12,
                    bodyFontFamily: 'Inter',
                    bodyFontSize: 11,
                    backgroundColor: 'rgba(53, 60, 70, 0.48)',
                    cornerRadius: 3,
                },
                watermark: {
                    image: this.watermarksUrl+'small.png',
                    opacity: 0.6,
                    alignX: "middle", // top, middle, bottom
                    alignY: "middle", // top, middle, bottom
                    alignToChartArea: true,
                    position: "back", // front, back
                }
			}
        };
    },
    methods: {
        getChartDataSet: function(newData, brentDeviation) {
            var i,
                total,
                randomness,
                val,
                dataSource = newData,
                dataChart = [],
                minBrentDeviation = -0.05,
                maxBrentDeviation = 0.05,
                randBrentDeviation;

            randomness = (brentDeviation && dataSource.code === 'BRENT');

            total = dataSource.values.length;
            for (i=0; i<total; i++) {
                randBrentDeviation = (randomness) ? Math.random() * (maxBrentDeviation - minBrentDeviation) + minBrentDeviation : 0;

                val = (!randomness) ? parseFloat(dataSource.values[i].value) : fixFP(parseFloat(dataSource.values[i].value)+randBrentDeviation, 2);
                dataChart.push({
                    t: moment(dataSource.values[i].date, this.DATE_FORMAT).toDate(),
                    y: val,
                });
            }

            return {
                label: (this.tooltipValueName) ? this.tooltipValueName : dataSource.code,
                fill: true,
                backgroundColor: 'rgba(235, 245, 255, 0.4)',
                borderColor: 'rgba(153, 204, 255, 1)',
                borderWidth: 1,
                pointRadius: 0,
                pointHitRadius: 6,
                pointHoverRadius: 4,
                pointBackgroundColor: 'rgba(153, 204, 255, 1)',
                pointBorderWidth: 0,
                spanGaps: true,
                data: dataChart,
            };
        },

        updateChartData: function(newData, brentDeviation) {
            this.chart.data.datasets.pop();
            this.chart.data.datasets.push(this.getChartDataSet(newData, brentDeviation));
            this.chart.update();
        },
    }
};